var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.StatusBanner
  }, [_c('div', {
    class: _vm.$style.headingWrapper
  }, [_c('h1', {
    staticClass: "h4",
    class: _vm.$style.heading
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('CBean', {
    class: _vm.$style.icon,
    attrs: {
      "icon": "check"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.text
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]), _vm._v(" "), !!_vm.button ? _c('div', {
    class: _vm.$style.bottomWrapper
  }, [_c('SButton', {
    class: _vm.$style.btn,
    attrs: {
      "theme": "primary",
      "rounded": "",
      "n-link": "",
      "href": _vm.button.to
    }
  }, [_vm._v("\n      " + _vm._s(_vm.button.text) + "\n    ")])], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };